import * as React from "react";
import { IFetchOrderProductsResponse } from "./fetchOrderProducts";

export const MemberProductsContext =
  // eslint-disable-next-line unicorn/no-null
  React.createContext<IFetchOrderProductsResponse | null>(null);

export function useMemberProducts() {
  const value = React.useContext(MemberProductsContext);

  if (value === null) {
    throw new Error("`Missing ProductsContext` in tree.");
  }

  return value;
}
